<router-outlet>
    <ngx-ui-loader></ngx-ui-loader>
</router-outlet> 

<div class="app-version">
 © Company | Version {{ appVersion }}
</div>
